import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { IonRouterOutlet } from '@ionic/angular/standalone';
import { isNil } from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { EVENT } from '@providers/event/event.enum';
import { EventService } from '@providers/event/event.service';
import { Back } from './back.interface';

/**
 * Back Component.
 *
 * @exports
 * @class BackComponent
 */
@Component({
  selector: 'app-back',
  template: ``,
  standalone: true
})
export class BackComponent implements OnDestroy, OnInit {
  private readonly event = inject(EventService);
  private readonly nav = inject(NavController);

  readonly router = input.required<IonRouterOutlet>();

  destroyed = new Subject<boolean>();

  /**
   * On component initialized.
   */
  ngOnInit(): void {
    this.setup();
  }

  /**
   * NgOnDestroy.
   *
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  /**
   * Navigate back.
   *
   * @param {Back} payload Back.
   * @memberof BackComponent
   */
  async back(payload: Back = {}): Promise<void> {
    if (
      (payload.backTo && isNil(payload.useBackToIfRouterCannotGoBack)) ||
      (payload.backTo && payload.useBackToIfRouterCannotGoBack === false)
    ) {
      this.nav.navigateRoot(payload.backTo);
    } else {
      if (this.router().canGoBack()) {
        await this.nav.pop();
      } else {
        if (payload.backTo && payload.useBackToIfRouterCannotGoBack)
          this.nav.navigateRoot(payload.backTo);
        else this.nav.back();
      }
    }
  }

  /**
   * Setup toast.
   *
   * @memberof BackComponent
   */
  setup(): void {
    this.event
      .listen(EVENT.BACK)
      .pipe(takeUntil(this.destroyed))
      .subscribe(this.back.bind(this));
  }
}
